import { Context } from "@nuxt/types/app";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function (context: Context) {
  function priceFormatToNumber(value: null | string): number {
    if (!value) {
      return 0;
    }
    // remove dots on cost string
    const costWithoutDots = value.split(".").join("");
    // convert cost string to number
    const cost = parseInt(costWithoutDots, 10);
    return cost;
  }

  return {
    priceFormatToNumber,
  };
}
